
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { FaUsersCog, FaBolt, FaHistory, FaCog } from "react-icons/fa";
import './AdminDashboard.css';

const AdminDashboard = () => {
  const [userBal, setUserBal] = useState('');
  const [todayRecharge, setTodayRecharge] = useState('');
  const [todayRechargeAmount, setTodayRechargeAmount] = useState('');
  const [superAdminName, setSuperAdminName] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [IsLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const fnManageOrganizationClick = (e) => {
    navigate("/Admin/ManageOrganization");
  }

  const fnRechargeClick = (e) => {
    navigate("/Admin/Recharge");
  }

  const fnAdminTransactions = (e) => {
    navigate("/Admin/TransactionHistory")
  }

  useEffect(() => {
    let TokenVal = localStorage.getItem('jwtToken');
    fnDashboardLoad();
    if (TokenVal === null || TokenVal === "" || TokenVal === undefined) {
      navigate("/");
    }
  }, []);

  function fnDashboardLoad() {
    const BASE_URL = window.BASE_URL + '/get_dashboardInfo';
    var config = {
      method: 'get',
      url: BASE_URL,
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem('jwtToken'),
      }
    };

    setIsLoading(true);
    axios.request(config)
      .then(function (response) {
        if (response != null && response != undefined && response.data != null && response.data != undefined && response.data.results != null && response.data.results != undefined) {
          setUserBal(response.data.results.userBalance);
          setTodayRecharge(response.data.results.todaysRecharges);
          setTodayRechargeAmount(response.data.results.rechargeAmount);
          if (response.data.results.userInfo != null && response.data.results.userInfo != undefined) {
            setSuperAdminName(response.data.results.userInfo.name);
            setMobileNumber(response.data.results.userInfo.mobile);
          }
        }
        setIsLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setIsLoading(false);
      });
  }

  return (
    <div className="admin-dashboard-container">
      {/* Loader */}
      {IsLoading && (
        <div className="loader-overlay">
          <div className="loader-box">
            <div className="spinner"></div>
            <p className="loader-text">Loading...</p>
          </div>
        </div>
      )}

      {/* Header */}
      <div className="admin-header">
        <div className="admin-header-content">
          <h1 className="admin-header-title">Dashboard</h1>
        </div>
      </div>

      <div className="admin-main">
        {/* Balance Card */}
        <div className="admin-balance-card">
          
          <div className="admin-balance-section">
            <p className="admin-balance-label">Balance Units</p>
            <h2 className="admin-balance-amount">{userBal}</h2>
          </div>
          <div className="admin-info-grid">
            <div className="admin-info-item">
              <p className="admin-info-label">Admin Name</p>
              <p className="admin-info-value">{superAdminName}</p>
            </div>
            <div className="admin-info-item">
              <p className="admin-info-label">Mobile</p>
              <p className="admin-info-value">{mobileNumber}</p>
            </div>
          </div>
        </div>

        {/* Today's Stats Cards */}
        <div className="admin-stats-grid">
          <div className="admin-stat-card">
            <div className="admin-stat-content">
              <div className="admin-stat-number">{todayRecharge}</div>
              <div className="admin-stat-label">Today's User Recharge</div>
            </div>
          </div>
          <div className="admin-stat-card">
            <div className="admin-stat-content">
              <FaHistory className="admin-stat-icon" />
              <div className="admin-stat-number">{todayRechargeAmount}</div>
              <div className="admin-stat-label">Today's Recharge Units</div>
            </div>
          </div>
        </div>

        {/* Organization Button */}
        <div className="admin-org-card" onClick={fnManageOrganizationClick}>
          <FaUsersCog className="admin-org-icon" />
          <span className="admin-org-text">Organization</span>
        </div>

        {/* Action Buttons */}
        <div className="admin-action-buttons">
          <button onClick={fnRechargeClick} className="admin-action-btn">
            Recharge Now
          </button>
          <button onClick={fnAdminTransactions} className="admin-action-btn">
            Transaction History
          </button>
        </div>

        {/* Settings Button */}
        <button className="admin-settings-fab">
          <FaCog className="admin-settings-icon" />
        </button>
      </div>
    </div>
  );
};

export default AdminDashboard;